import { c as _c } from "react/compiler-runtime";
import { useFrame, useThree } from "@react-three/fiber";
import { type FC, useEffect, useLayoutEffect, useRef } from "react";

/**
 * OrbitControls.connect() sets touch-action: none on the canvas. When the
 * canvas should not capture gestures (mobile / decorative scenes), keep scroll
 * working by forcing pointer-events: none and touch-action: auto.
 * useFrame reapplies styles in case connect() runs again later.
 */
export const OrbitModelCanvasTouchScroll: FC<{
  active: boolean;
}> = t0 => {
  const $ = _c(9);
  const {
    active
  } = t0;
  const gl = useThree(_temp);
  const canvasRef = useRef(null);
  let t1;
  if ($[0] !== gl.domElement) {
    t1 = () => {
      canvasRef.current = gl.domElement;
    };
    $[0] = gl.domElement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== gl) {
    t2 = [gl];
    $[2] = gl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[4] !== active) {
    t3 = () => {
      if (!active) {
        return;
      }
      const canvas = canvasRef.current;
      if (!canvas) {
        return;
      }
      canvas.style.pointerEvents = "none";
      canvas.style.touchAction = "auto";
    };
    $[4] = active;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useFrame(t3);
  let t4;
  let t5;
  if ($[6] !== active) {
    t4 = () => {
      const canvas_0 = canvasRef.current;
      if (!canvas_0) {
        return;
      }
      if (active) {
        return () => {
          canvas_0.style.removeProperty("pointer-events");
          canvas_0.style.touchAction = "none";
        };
      }
      canvas_0.style.removeProperty("pointer-events");
      canvas_0.style.touchAction = "none";
    };
    t5 = [active];
    $[6] = active;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  return null;
};
function _temp(state) {
  return state.gl;
}